import { Component, OnInit } from '@angular/core';
import { DeviceSyncStatus } from '@era/locations-sdk';
import { DeviceStoreActions } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ForceSyncService } from '../device-mdm-sync-force/device-mdm-sync-force.service';
import { DeviceMdmSyncForceContainerComponent } from '../device-mdm-sync-force/device-mdm-sync-force.container';
import { DeviceMdmSyncRetryComponent } from './device-mdm-sync-retry.component';
import { AsyncPipe } from '@angular/common';
import { DeviceSyncStatusSelectors } from '../../sub-features/device-sync/device-sync-statuses-store';

@Component({
  selector: 'era-device-mdm-sync-retry',
  templateUrl: './device-mdm-sync-retry.container.html',
  styleUrls: ['./device-mdm-sync-retry.container.scss'],
  imports: [DeviceMdmSyncForceContainerComponent, DeviceMdmSyncRetryComponent, AsyncPipe],
})
export class DeviceMdmSyncRetryContainerComponent implements OnInit {
  readonly deviceStatus$: Observable<DeviceSyncStatus>;
  private forceSync = false;

  constructor(
    private readonly statusStore: Store<DeviceSyncStatus>,
    private forceSyncService: ForceSyncService
  ) {
    this.deviceStatus$ = this.statusStore.select(DeviceSyncStatusSelectors.selectCurrentDeviceSyncStatus);
  }

  public retry(status: DeviceSyncStatus) {
    this.statusStore.dispatch(
      DeviceStoreActions.DeviceSyncStatusViewActions.retrySync({ udid: status.udid, forceSync: this.forceSync })
    );
  }

  ngOnInit() {
    this.forceSyncService.forceSync$.subscribe((value) => {
      this.forceSync = value;
    });
  }
}
